<!--
 * @Descripttion: 
 * @version: 
 * @Author: your name
 * @Date: 2025-02-18 15:22:46
 * @LastEditors: wuyujiang 563306293@qq.com
 * @LastEditTime: 2026-03-04 14:39:50
-->
<template>
  <div id="app" class="app">
    <transition name="component-fade" mode="out-in">
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive"></router-view>
      </keep-alive>
    </transition>

    <transition name="component-fade" mode="out-in">
      <router-view v-if="!$route.meta.keepAlive"></router-view>
    </transition>
  </div>
</template>
<script>
// import Vue from "vue";

export default {
  name: "App",
  data() {
    return {};
  },
  created() {
    // Get user info on app initialization
    this.getUserInfo();
  },
  mounted() {},
  methods: {
    async getUserInfo() {
      try {
        const res = await this.gets(this.allUrl.userInfo);
        if (res.data.code === 0) {
          console.log("!!----!!", res);
          const userData = res.data.data.userInfoRespVO;
          ssq.push("setLoginInfo", {
            user_id: res.data.data.userInfoRespVO.id, // 加密后的用户id, 必填！
            user_name: res.data.data.userInfoRespVO.id, // 对应用户名，可在客户资料查看, 必填
            description: `userId=${userData.id}\n gender=${userData.gender}\n country=${userData.country}\n vipLevel=${userData.vipLevel}\n anchorLevel=${userData.anchorLevel}\n balance=${res.data.data.integral}\n Entrance=\n `,
          });
          // this.$store.commit('setUserInfo', res.data.data);
        }
      } catch (e) {
        console.error("Failed to get user info", e);
      }
    },
  },
};
</script>
<style lang="less">
/* [v-cloak] {
  display: none;
} */
body,
html {
  width: 100vw;
  height: 100vh;
  overflow: hidden;
}
.mint-toast-text {
  font-size: 28px !important; /* 设置您想要的字体大小 */
}
/* .mint-toast {
  font-size: 100px !important;
} */
.mytoast {
  z-index: 100000001 !important;
  font-size: 28px !important; /* 设置您想要的字体大小 */
}

/* 阿拉伯语时，返回按钮和编辑按钮图标镜像翻转 */
.lang-ar {
  img[src*="back"],
  img[src*="whatsapp"],
  .whatsappIcon,
  .backBtn,
  .jingxiang,
  .editBtn {
    transform: scaleX(-1);
  }
}
</style>
